import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosGestionMixin = {
  computed: {
    permisosGestion() {
      return {
        accesoModulo: tienePermiso('moduloGestionEmpleados'),
        registrarEmpleado: tienePermiso('registrarEmpleado'),
        editarEmpleado: tienePermiso('editarEmpleado'),
      };
    },
  },
};
